import React from 'react';
import {
	SLOT_PREVIEW_MAX,
	formatDueLabel,
	isOverdue,
} from '../../services/spaceItemsModel';

/* A named content slot in a space shell.

   TWO STATES, and the empty one is not a placeholder. Given `items` it renders
   the list; given none it renders the believable empty state it always had. The
   private spaces that aren't wired to Firestore yet (Owners, Barbara) pass no
   `items` at all and therefore render exactly as before — that is why the prop
   is optional rather than defaulted to [], which would have made a live-but-empty
   slot indistinguishable from an unwired one.

   Props: { name, icon, hint, sub, cta, ctaIcon, primary, big, phase, items } */
function SpaceSlot({
	name,
	icon,
	hint,
	sub,
	cta,
	ctaIcon = 'fa-plus',
	primary = false,
	big = false,
	phase,
	items,
	now = new Date(),
}) {
	const hasItems = Array.isArray(items) && items.length > 0;
	const visible = hasItems ? items.slice(0, SLOT_PREVIEW_MAX) : [];
	const overflow = hasItems ? items.length - visible.length : 0;

	return (
		<section className={`psp-slot${big ? ' psp-slot--big' : ''}`}>
			<header className='psp-slot__head'>
				<i
					className={`fa-sharp-duotone fa-solid ${icon} psp-slot__head-icon`}
				/>
				<span className='psp-slot__head-name'>{name}</span>
				{hasItems && (
					<span className='psp-slot__count'>{items.length}</span>
				)}
				{phase && (
					<span className='psp-pill psp-pill--muted'>{phase}</span>
				)}
			</header>

			{hasItems ? (
				<div className='psp-slot__filled'>
					<ul className='psp-slot__list'>
						{visible.map((item) => {
							const due = formatDueLabel(item.dueAt, now);
							return (
								<li key={item.id} className='psp-slot__item'>
									<span className='psp-slot__item-title'>
										{item.title}
									</span>
									{item.recurring && (
										<i
											className='fa-sharp fa-solid fa-repeat psp-slot__item-flag'
											title='Recurring'
										/>
									)}
									{due && (
										<span
											className={`psp-slot__item-due${
												isOverdue(item, now)
													? ' is-overdue'
													: ''
											}`}>
											{due}
										</span>
									)}
								</li>
							);
						})}
					</ul>
					{overflow > 0 && (
						<div className='psp-slot__more'>
							{`+${overflow} more`}
						</div>
					)}
				</div>
			) : (
				<div className='psp-slot__body'>
					<span className='psp-slot__bubble'>
						<i className={`fa-sharp-duotone fa-solid ${icon}`} />
					</span>
					<div>
						<div className='psp-slot__hint'>{hint}</div>
						{sub && <div className='psp-slot__sub'>{sub}</div>}
					</div>
					{cta && (
						<button
							type='button'
							className={`psp-slot__cta ${
								primary ? 'btn-cyv-teal' : 'btn-cyv-ghost'
							}`}>
							<i className={`fa-sharp fa-solid ${ctaIcon}`} />
							{cta}
						</button>
					)}
				</div>
			)}
		</section>
	);
}

export default SpaceSlot;
